import 'whatwg-fetch';
import { api } from 'config';
import StorageService from 'services/StorageService';
import { consumer, ecommerce } from 'config/constants';

const cachePromise = {
    rating: {
        promise: null,
        key: null
    }
}

const getProductRating = (ids) => {

    if(cachePromise.rating.promise && cachePromise.rating.key == ids) return cachePromise.rating.promise;

    const headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }
    let url = `/reviews/ratings?ids=${ids}`

    if(ecommerce.whiteLabel) {
        headers['x-consumer'] = consumer;
        headers['x-account'] = consumer;
    }

    cachePromise.rating.key = ids;
    cachePromise.rating.promise = fetch(api.catalog + url, {
        method: 'GET',
        headers
    })
        .then(data => data.json())
        .then((data)=> {
            cachePromise.rating.key = null;
            cachePromise.rating.promise = null;
            return data
        });
    return cachePromise.rating.promise;
}

const retrieveProduct = (review) => {
    const headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }

    if(ecommerce.whiteLabel) {
        headers['x-consumer'] = consumer;
        headers['x-account'] = consumer;
    }

    return fetch(api.catalog + `/reviews/retrieve/${review}`, {
        method: 'GET',
        headers
    }).then(data => data.json());
}

const listReviews = (id, from = 0, to = 10, params = '') => {
    const headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }

    let url = `/reviews/retrieve/list?product_id=${id}&from=${from}&to=${to}${params ? params : ''}`
    
    if(ecommerce.whiteLabel) {
        headers['x-consumer'] = consumer;
        headers['x-account'] = consumer;
    }

    
    return fetch(api.catalog + url, {
        method: 'GET',
        headers
    }).then(data => data.json());
}


const addReviewProduct = (productId, rating, title, text) => {
    const token = StorageService.getSecureItem('vtex_review');

    const headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
        'Content-Type': 'application/json',
        'authClient': token,
    }

    let payload = {
        "ProductId": productId,
        "Rating": rating,
        "Title": title ? title : '',
        "Text": text ? text : '',
    }

    if(ecommerce.whiteLabel) {
        headers['x-consumer'] = consumer;
        headers['x-account'] = consumer;
    }


    return fetch(api.catalog + `/review`, {
        method: 'POST',
        headers,
        body: JSON.stringify(payload),
    }).then(data => data.json());
}


const ReviewsServices = {
    getProductRating,
    retrieveProduct,
    addReviewProduct,
    listReviews
}

export default ReviewsServices;
